export { default as ExpenseVoucherSlot } from './ExpenseVoucherSlot';
